import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Association } from '../../../shared/association/association.model';
import { Router } from '@angular/router';

@Component({
  selector: 'lwa-association-access-card',
  templateUrl: './association-access-card.component.html',
  styleUrls: ['./association-access-card.component.scss'],
})
export class AssociationAccessCardComponent implements OnInit {

  @Input() association: Association;
  @Output() associationSelected = new EventEmitter<Association>();

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  onSelectAssociation(): void {
    this.router.navigate(['d', this.association.id]);
    this.associationSelected.emit(this.association);
  }
}
